import React from 'react';
import { ScreenSwitcher } from './components/ScreenSwitcher';
import { WithdrawModal } from './components/withdraw/WithdrawModal';
import { useWithdrawFlow } from './hooks/useWithdrawFlow';
export function App() {
  const flow = useWithdrawFlow();
  return <div className="min-h-screen w-full bg-slate-100 font-sans text-slate-900 antialiased" data-id="element-0" data-mp="3k78fdk6zxyy2">
      {/* Dimmed backdrop, as rendered behind a Lightning quick-action modal */}
      <div className="fixed inset-0 overflow-y-auto bg-slate-900/55" data-id="element-1" data-mp="2rlf5kqna9k1s">
        <main className="flex min-h-full items-center justify-center px-4 pb-20 pt-8" data-id="element-2" data-mp="2mmlvz9b4ad6w">
          <WithdrawModal flow={flow} data-id="element-3" data-mp="31b8gdpflpv4z" />
        </main>
      </div>
      <ScreenSwitcher active={flow.screen} onChange={flow.goTo} lenderVariant={flow.dead.lenderVariant} onLenderVariantChange={lenderVariant => flow.updateDead({
      lenderVariant
    })} data-id="element-4" data-mp="31cjo20c63n1d" />
    </div>;
}